import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {Price_PriceTag} from '../../../../types/Price';
import {PriceBoxProps} from '../PriceBox';
import {PriceBadge} from './PriceBadge';
import {PriceReduction} from './PriceReduction';
import {SalesRow} from './Shared';

export const PriceTags: FC<
  {priceTags: Price_PriceTag[]; 'data-testid'?: string} & Pick<
    PriceBoxProps,
    'CountdownComponent' | 'align' | 'hideBadges'
  >
> = ({
  priceTags,
  CountdownComponent,
  align = 'left',
  hideBadges,
  'data-testid': dataTestid,
}) => {
  return (
    <StyledSalesRow
      data-has-countdown={Boolean(
        CountdownComponent &&
          priceTags.some(
            priceTag =>
              priceTag.type?.$case === 'badge' && priceTag.type.badge.endsAt,
          ),
      )}
      $align={align}
    >
      {priceTags.map((priceTag, index) => {
        switch (priceTag.type?.$case) {
          case 'badge': {
            if (hideBadges) {
              return null;
            }

            return (
              <PriceBadge
                key={`${priceTag.type.badge.text}-${index}`}
                badge={priceTag.type.badge}
                CountdownComponent={CountdownComponent}
              />
            );
          }

          case 'reduction': {
            return (
              <PriceReduction
                key={`priceTag-reduction-${index}`}
                reduction={priceTag.type.reduction}
                data-testid={dataTestid}
              />
            );
          }

          default:
            return null;
        }
      })}
    </StyledSalesRow>
  );
};

const StyledSalesRow = styled(SalesRow)`
  column-gap: 6px;

  [data-reduce-price-tags-spacing='true'] & {
    column-gap: 4px;
  }
`;
